import React, { useState } from "react";
import { ListItem, ListItemAvatar, Avatar, ListItemText, Typography, IconButton, Box, TextField } from '@mui/material';
import { CheckTwoTone, Delete, Edit } from '@mui/icons-material';
import { CHANGE, TYPE_SALE } from "../../helpers/enums";
import DiscountChip from '../DiscountChip';

const CarritoData = ({ data, onRemove, onEdit, onChangePrice, withDescription }) => {
  const [editing, setEditing] = useState(false)
  const [typeOperation, setTypeOperation] = useState(TYPE_SALE.MENOR);

  const handleEdit = () => {
    console.log(editing)
    setEditing(!editing)
  }

  const handlePrice = (typeSale, value) => {
    onChangePrice && onChangePrice(typeSale, value)
  }

  return <Box display='flex' >
    <ListItem
      alignItems="flex-start"
      sx={{ paddingRight: '120px' }}
      secondaryAction={
        <Box display='flex' flexDirection='row' alignItems="center">
          {/* <Typography alignSelf='center' aria-label="delete" sx={{background: 'red'}}>
            {editing ? <TextField sx={{width: 50}}/> : data.quantity}
          </Typography> */}
          {editing ? (
            <Box display='flex' flexDirection='column'>
              <Box>
                <IconButton onClick={() => {
                  if (TYPE_SALE.MAYOR !== typeOperation) {
                    setTypeOperation(TYPE_SALE.MAYOR)
                    handlePrice(TYPE_SALE.MAYOR)
                  }
                }} sx={{ background: typeOperation === TYPE_SALE.MAYOR ? 'green' : null, padding: 0.3 }}>
                  <Typography
                    sx={{ display: 'inline' }}
                    component="span"
                    variant="body2"
                    color={typeOperation === TYPE_SALE.MAYOR ? 'white' : "text.primary"}
                  >
                    My
                  </Typography>
                </IconButton>
                <IconButton onClick={() => {
                  setTypeOperation(TYPE_SALE.MENOR)
                  handlePrice(TYPE_SALE.MENOR)
                }} sx={{ background: typeOperation === TYPE_SALE.MENOR ? 'green' : null, padding: 0.3 }}>
                  <Typography
                    sx={{ display: 'inline' }}
                    component="span"
                    variant="body2"
                    color={typeOperation === TYPE_SALE.MENOR ? 'white' : "text.primary"}
                  >
                    Mn
                  </Typography>
                </IconButton>
                <IconButton onClick={() => {
                  handlePrice(CHANGE.QUANTITY, 1)
                  setTypeOperation(TYPE_SALE.OTRO)
                  handlePrice(TYPE_SALE.OTRO)
                }} sx={{ background: typeOperation === TYPE_SALE.OTRO ? 'green' : null, padding: 0.3 }}>
                  <Typography
                    sx={{ display: 'inline' }}
                    component="span"
                    variant="body2"
                    color={typeOperation === TYPE_SALE.OTRO ? 'white' : "text.primary"}
                  >
                    Otro
                  </Typography>
                </IconButton>
              </Box>
              <TextField
                value={data.quantity}
                onChange={(e) => handlePrice(CHANGE.QUANTITY, e.target.value)}
                sx={{ width: 65 }}
                size="small"
              />
            </Box>
          ) : (<>
            <Typography sx={{ textAlign: 'center', width: 50 }} padding={0}>{data.quantity}</Typography>
            <IconButton edge="end" aria-label="delete" onClick={() => onRemove()}>
              <Delete />
            </IconButton>
          </>
          )}
          <IconButton edge="end" aria-label="delete" onClick={handleEdit} sx={{ marginLeft: 2 }}>
            {editing ? <CheckTwoTone /> : <Edit />}
          </IconButton>
        </Box>
      }
    >
      <Box display='flex' flexDirection='row' paddingRight='50px'>
        <ListItemAvatar>
          <Avatar alt={data.tittle} src={data.image} />
        </ListItemAvatar>
        <ListItemText
          primary={data.tittle}
          secondary={
            <React.Fragment>
              <Box>
                {editing && [TYPE_SALE.OTRO].includes(typeOperation) ? <TextField
                  value={data.subtittle}
                  onChange={(e) => handlePrice(CHANGE.PRICE, e.target.value)}
                  sx={{ width: 110 }}
                  size="small"
                /> :
                  <Box display="flex" flexDirection="column" gap={0.5}>
                    <Typography
                      sx={{ display: 'inline' }}
                      component="span"
                      variant="body2"
                      color="text.primary"
                    >
                      {'$ ' + data.subtittle}
                    </Typography>
                    
                    {/* Mostrar información de descuento si existe */}
                    {data.discount_info && (
                      <>
                        <DiscountChip 
                          discountInfo={data.discount_info} 
                          size="medium" 
                          showOfferName={true}
                          sx={{ maxWidth: 'fit-content' }}
                        />
                        <Typography variant="caption" sx={{ color: 'green', fontWeight: 'bold' }}>
                          ¡Ahorraste ${data.discount_info.discount_amount}!
                        </Typography>
                      </>
                    )}
                  </Box>
                }
              </Box>
              {withDescription && '  -- ' + data.description}
            </React.Fragment>
          }
        />
      </Box>
    </ListItem>
  </Box>
}

export default CarritoData;